import { Component, OnInit,ViewChild,AfterViewInit } from '@angular/core';
import { AuthService } from '../../../services-http/auth/auth.service';
import { Router } from '@angular/router';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { NotificationService } from '../../../services-http/notification/notification.service'
import Swal from 'sweetalert2'


@Component({
  selector: 'app-takaful',
  templateUrl: './takaful.component.html',
  styleUrls: ['./takaful.component.scss']
})
export class TakafulComponent implements OnInit {
  @ViewChild('frame') frame: ModalDirective;
  @ViewChild('basicModal') basicModal: ModalDirective;
  @ViewChild('pop') pop: any;


  user:any = JSON.parse(localStorage.getItem('currentUser'));
  userType:any;
  coopName:any;
  unreadNotifCount:any=0;

  constructor(
    private authService: AuthService,
    private router: Router,
    public notification:NotificationService
  ) {

  }


  closeNotificationPopover = () => {
    if (this.pop) {
      this.pop.hide();
    }
  };


  navigate(p){

    if(p.variantid==2||p.variantid==83){
      return this.router.navigateByUrl('/Takaful/comprehensive/'+p.variantid+'/quoteId/0/'+this.user.iloginId);
    }

  }
  

  // ngAfterViewInit() {

  //   console.log(this.user);

  //   if(this.user.checkunpayed){
  //     this.basicModal.show();
  //   }
  // }


  logout() {
    this.authService.logout();
  }
  
   
  gotoProfileView() {
    this.router.navigateByUrl('/Takaful/cac-profile/' + this.user['userId'] + '/view');
  }

  

  ngOnInit() {     
    this.getnotif()
  
  }



  getnotif(){
    this.notification.getNotification(this.user.iloginId)
      .subscribe((res: any) => {
        
        this.unreadNotifCount = res.filter((x:any) => x.status == 1).length;
    })
  }

}
